export const darkModeKey = 'darkMode'
